import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async';
import useDebouncedCallback from 'utils/customHooks/useDebouncedCallback';
//api
import { getAllEditorials } from 'api/products';

const SearchEditorialInput = ({ value, onSelected, defaultEditorial = null, showLabel = '' }) => {
  const { t } = useTranslation(['backoffice']);
  const [editorialSelected, setEditorialSelected] = useState(null);

  useEffect(() => {
    if (defaultEditorial) {
      setEditorialSelected({
        label: defaultEditorial.nombre_fiscal || defaultEditorial.value,
        value: defaultEditorial.id || defaultEditorial.value,
      });
    } else {
      setEditorialSelected(null);
    }
  }, [defaultEditorial]);

  // Resetear cuando value se vuelve null o undefined
  useEffect(() => {
    if (!value) {
      setEditorialSelected(null);
    }
  }, [value]);

  const onSearch = async (value) => {
    if (value && value.length > 1) {
      const { status, data } = await getAllEditorials({ 
        search: value, 
        page: 1, 
        page_size: 10,
        fields: 'id,nombre_fiscal'
      });
      if (status === 200 && data?.results) {
        return data.results.map((item) => ({
          ...item,
          label: item.nombre_fiscal || '',
          value: item.id,
        }));
      }
    }
    return [];
  };

  const loadOptions = useDebouncedCallback((value, callback) => {
    onSearch(value).then((options) => callback(options));
  }, 1000);

  return (
    <div>
      {showLabel && (
        <Form.Label className="order-control-filters__label">
          {showLabel}
        </Form.Label>
      )}
      <AsyncSelect
        cacheOptions
        defaultOptions={editorialSelected ? [editorialSelected] : []}
        defaultValue={editorialSelected}
        defaultInputValue={editorialSelected?.label}
        loadOptions={loadOptions}
        onChange={(selected) => {
          setEditorialSelected(selected);
          onSelected(selected);
        }}
        placeholder={t('searchByName') || 'Buscar editorial...'}
        classNamePrefix="editorial-filter-input"
        isClearable
        value={value !== undefined && value !== null ? value : editorialSelected}
        styles={{
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#e9ecef' : 'white',
            color: state.isFocused ? '#212529' : base.color,
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '#e9ecef',
            },
          }),
        }}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: 'neutral60',
          },
        })}
      />
    </div>
  );
};

SearchEditorialInput.propTypes = {
  onSelected: PropTypes.func,
  value: PropTypes.any,
  defaultEditorial: PropTypes.object,
  showLabel: PropTypes.string,
};

export default SearchEditorialInput;
